jQuery(document).ready(function($) {
  if (1 === 0) {
    // Debugger to output jQuery Version
    typeof window.jQuery !== 'undefined'
      ? console.log(window.jQuery.fn.jquery)
      : 'jQuery not found!'
  }

  $(document).on('gform_confirmation_loaded', function(event, formId) {
    window.dataLayer = window.dataLayer || []
    var eventName = 'unknownFormSubmission'

    if (formId == 7) {
      eventName = 'contactFormSubmission'
    }

    // Add to GTM
    window.dataLayer.push({
      event: eventName,
      formID: formId,
    })
  })
})
